import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=da1d4f6e&scoped=true&"
import script from "./BottomNavigation.vue?vue&type=script&lang=ts&"
export * from "./BottomNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=da1d4f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1d4f6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBottomNavigation,VBtn})
